import muster from '@dbk-legacy/muster';
import pymtdashboard from './payment-dashboard';
import pymtbenefadd from './payment-add-beneficiary';
import payments from './payments';
import paymentsummary from './payment-summary';
import paymentfilter from './filter';

export default () => muster()
  .import(null, pymtbenefadd())
  .import(null, pymtdashboard())
  .import(null, payments())
  .import(null, paymentsummary())
  .import(null, paymentfilter());

